import type { I18nFn } from '#/i18n/types/I18nFn';
import { ApiOrgType } from '#/modules/listing/orgs/api/types/ApiOrgType';

import { getOrgDetailFields } from './getOrgDetailFields';

export function getEditFields(
  i18n: I18nFn,
  // TODO: Fix this the next time the file is edited.
  // oxlint-disable-next-line typescript/no-explicit-any
  values: Record<string, any>,
  showVatNumber: boolean,
  orgType: ApiOrgType,
  isPending: boolean,
  donateEnabled: boolean | null,
  membershipCallout: React.ReactNode | null,
) {
  return [
    {
      title: i18n('Basic Info'),
      sections: [
        {
          rows: [
            {
              fields: ['name'],
            },
            {
              fields: ['logo'],
            },
          ],
        },
      ],
    },
    {
      title: i18n('Organization Details'),
      sections: [
        {
          rows: [
            {
              fields: ['locale'],
            },
            ...(showVatNumber
              ? [
                  {
                    fields: ['vatNumber'],
                  },
                ]
              : []),
            {
              fields: ['linkedinId'],
            },
            !['CONSULTANT', 'RECRUITER', 'CORPORATION', 'COMMUNITY'].includes(
              values.orgType,
            )
              ? {
                  fields: ['governmentId'],
                }
              : {
                  fields: [],
                },
            ...(isPending
              ? getOrgDetailFields({
                  orgType: values.orgType,
                })
              : [
                  {
                    fields: [],
                  },
                ]),
          ],
        },
      ],
    },
    {
      title: i18n('Additional Details'),
      sections: [
        {
          rows: [
            // TODO: Fix this from eslint v9 update
            // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
            ...(orgType === 'NONPROFIT'
              ? [
                  {
                    fields: ['mission'],
                  },
                ]
              : []),
            {
              fields: ['description'],
            },
            // TODO: Fix this from eslint v9 update
            // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
            ...(orgType === 'CORPORATION'
              ? []
              : [
                  {
                    fields: ['areasOfFocus'],
                  },
                ]),
          ],
        },
      ],
    },
    ...(['NONPROFIT', 'GOVERNMENT'].includes(orgType)
      ? [
          {
            title: i18n('Accept Donations'),
            preTitle: i18n('Members Only'),
            disabled: !donateEnabled,
            beforeSection: membershipCallout,
            glowUp: donateEnabled,
            sections: [
              {
                rows: [
                  {
                    fields: ['donationLink'],
                  },
                ],
              },
            ],
          },
        ]
      : []),
    {
      title: i18n('Contact'),
      sections: [
        {
          rows: [
            {
              fields: ['links'],
            },
            {
              fields: ['email'],
            },
            {
              fields: ['phone'],
            },
          ],
        },
      ],
    },
    {
      title: i18n('Location'),
      sections: [
        {
          rows: [
            {
              fields: ['locationType'],
            },
            {
              fields: ['address'],
            },
          ],
        },
      ],
    },
    {
      title: i18n('Media Gallery'),
      sections: [
        {
          rows: [
            {
              fields: ['banner'],
            },
            {
              fields: ['slideshowItems'],
            },
          ],
        },
      ],
    },
  ];
}
